import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import block from './block.json';

export type ColumnProps = ChildrenProps & ThemeProps;

export const Column: FC<ColumnProps> & BlockConfigs = ({
	children,
	theme = {},
}) => {
	const { variant /*, blockTheme*/ } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx('supt-column');

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			{children}
		</div>
	);
};

Column.slug = block.slug;
Column.title = block.title;
